import { useCallback } from 'react';

import type { generatePath } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { generateNextPath as generateNextPathUtil } from 'lib/routeHelper';

export const useBranchQueryParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const branchId = params.get('branchId');
  const queryParams = branchId ? { branchId } : {};

  const generateNextPath = useCallback(
    <Path extends string>(
      template: Path,
      urlParams?: Parameters<typeof generatePath<Path>>[1],
      additionalQueryParams?: { [key: string]: string | undefined },
    ) => {
      const mergedQueryParams = {
        ...queryParams,
        ...additionalQueryParams,
      };

      return generateNextPathUtil(template, urlParams, mergedQueryParams);
    },
    [queryParams],
  );

  return {
    branchId,
    queryParams,
    generateNextPath,
  };
};
